export const hasNotAnsweredPermissions = (gdpr) =>
  Object.entries(gdpr).reduce((prev, arr) => arr[1] === null || prev, false);
